export default __webpack_public_path__ + "static/media/logo SL_logo orizzontale 2_grey.a2d5b3fc.png";